export default __webpack_public_path__ + "static/1461-7a398b89e6d66d69197e535f7d7be586.gif";